import { createFileRoute } from "@tanstack/react-router"
import { reportsViewLayoutHandle } from "src/views/ReportsView/constants"
import { ReportsView } from "src/views/ReportsView/ReportsView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/reports/")({
	component: ReportsView,
	staticData: reportsViewLayoutHandle,
})
